import { useState } from 'react';
import { navLinks } from '@/mocks/homeData';
import { useToast } from '@/hooks/useToast';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { show, node } = useToast();

  return (
    <header className="bg-background-50/90 backdrop-blur border-b border-background-200/80">
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-3 cursor-pointer">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-foreground-950 text-background-50">
            <i className="ri-file-search-line w-5 h-5 flex items-center justify-center" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              爆料黑料
            </span>
            <span className="mt-1 text-[10px] tracking-[0.3em] text-foreground-500">
              深扒 · 复盘 · 证据
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-4 py-2 text-sm text-foreground-700 rounded-md transition-colors cursor-pointer hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => show('搜索功能即将上线，当前为演示入口')}
            className="hidden md:flex items-center justify-center w-10 h-10 rounded-md border border-background-300 text-foreground-600 transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-600"
            aria-label="搜索"
          >
            <i className="ri-search-line w-5 h-5 flex items-center justify-center" />
          </button>
          <a
            href="#subscribe"
            className="hidden md:flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 whitespace-nowrap transition-colors cursor-pointer hover:bg-primary-600"
          >
            <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center" />
            更新提醒
          </a>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            className="flex md:hidden items-center justify-center w-10 h-10 rounded-md border border-background-300 text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <nav className="flex flex-col py-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-700 rounded-md cursor-pointer hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="flex items-center justify-center gap-2 w-full px-4 py-3 text-sm font-medium rounded-md bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center" />
            更新提醒
          </a>
        </div>
      )}
      {node}
    </header>
  );
}